import React, { useState } from "react";
import { UserPlus, Loader2, ArrowLeft, Tags } from "lucide-react";
import logo from "../assets/logo.png";
import CategoryPicker from "./CategoryPicker";

const HERO_IMAGE =
  "https://autohebdosport.com/images/coches/salones/2025/autopia/segundo-previo/autopia-2025.jpg";

const FIELDS = [
  { label: "Nombre", key: "name", autoComplete: "given-name" },
  { label: "Apellido", key: "surname", autoComplete: "family-name" },
  { label: "Email", key: "email", type: "email", autoComplete: "email" },
  { label: "Contraseña", key: "password", type: "password", autoComplete: "new-password" },
  { label: "Confirmar contraseña", key: "confirmPassword", type: "password", autoComplete: "new-password" },
  { label: "Código de invitación", key: "invitationCode" },
];

export default function RegisterComponent({ registerUser }) {
  const [form, setForm] = useState({
    name: "",
    surname: "",
    email: "",
    password: "",
    confirmPassword: "",
    invitationCode: "",
    networkingCategories: []
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Sin ninguna categoría el perfil no aparece en los filtros de Networking,
    // así que se pide al menos una ya en el registro
    if (form.networkingCategories.length === 0) {
      alert("Elige al menos una categoría de networking.");
      return;
    }

    setIsLoading(true);

    try {
      const success = await registerUser(form);
      if (!success) {
        alert("Registro fallido. Verifica tus datos.");
      }
    } catch (err) {
      alert("Error inesperado.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="dyd-auth dyd-auth-single">
      <div className="dyd-auth-bg" style={{ backgroundImage: `url(${HERO_IMAGE})` }} />
      <div className="dyd-auth-veil" />
      <div className="dyd-auth-grid" />

      <div className="dyd-auth-card dyd-rise">
        <img src={logo} alt="DrivingYourDream Club" className="dyd-auth-logo" />

        <h2>Crear cuenta</h2>
        <p className="dyd-auth-sub">Únete a DrivingYourDream Club</p>

        <form onSubmit={handleSubmit}>
          <div className="dyd-auth-fields">
            {FIELDS.map(({ label, key, type = "text", autoComplete }) => (
              <div key={key} className="dyd-field">
                <label className="dyd-label" htmlFor={`reg-${key}`}>{label}</label>
                <input
                  id={`reg-${key}`}
                  className="dyd-input"
                  type={type}
                  value={form[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                  autoComplete={autoComplete}
                  required
                />
              </div>
            ))}

            <div className="dyd-field">
              <label className="dyd-label" htmlFor="reg-categories">
                <Tags size={13} /> Categorías de networking
              </label>
              <CategoryPicker
                id="reg-categories"
                value={form.networkingCategories}
                onChange={(categories) => handleChange("networkingCategories", categories)}
              />
              <small className="dyd-hint">
                Así te encontrarán los demás miembros en la pestaña Networking. Podrás cambiarlas
                después desde tu perfil.
              </small>
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="dyd-btn dyd-btn-primary dyd-btn-block dyd-btn-lg"
          >
            {isLoading ? (
              <>
                <Loader2 size={17} className="dyd-spin" />
                Creando cuenta…
              </>
            ) : (
              <>
                <UserPlus size={17} />
                Registrarse
              </>
            )}
          </button>
        </form>

        <a href="/" className="dyd-auth-link">
          <ArrowLeft size={13} />
          ¿Ya tienes cuenta? <span>Inicia sesión</span>
        </a>
      </div>
    </div>
  );
}
